import React, { useEffect, useState } from 'react';
import { JBAlert, JBButton, JBTypography } from '@jbhi-fi/lanyard-ui';
import { useTracking, trackingContext } from '@jbhi-fi/components/src/Tracking';
import { styles } from './AuthError.css';

export const AuthError = ({ handleLogin }: { handleLogin: () => Promise<void> }): JSX.Element => {
  const [loading, setLoading] = useState(false);
  const { tracker } = useTracking({
    context: trackingContext.account,
    category: 'my account',
    group: 'Authentication Error',
  });

  useEffect(() => {
    tracker.trackView();
    tracker.trackError({ errorMsg: "We're having trouble finding some of your details." });
  }, []);

  const handleClick = async (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    if (!loading) {
      setLoading(true);
      tracker.trackClick({ label: 'Please log back in to try again.' });
      await handleLogin();
    }
  };

  return (
    <JBAlert type="error" heading="Sorry, something's gone wrong." showIcon closable classes={styles.container}>
      <JBTypography type="p" margin="0 0 16px 0">
        We're having trouble finding some of your details.
        {loading ? (
          ' Loading...'
        ) : (
          <>
            Please{' '}
            <JBButton
              classes={styles.button}
              label={loading ? 'Loading...' : 'log back in'}
              type="link"
              onClick={handleClick}
            />{' '}
            to continue.
          </>
        )}
      </JBTypography>
    </JBAlert>
  );
};
